<template>
  <app-card
    id="conditions-card"
    class="p-6 flex flex-col"
    :status="
      project.conditions_evidence_approved_at ? 'complete' : 'incomplete'
    "
  >
    <div>
      <app-badge
        v-if="project.conditions_evidence_approved_at"
        type="positive"
        icon="check"
      >
        Approved
      </app-badge>
      <app-badge
        v-else-if="project.conditions_evidence_file_id"
        type="neutral"
        icon="check"
      >
        Awaiting Approval
      </app-badge>
      <app-badge
        v-else
        type="neutral"
        icon="important"
      >
        Required
      </app-badge>
      <h2 class="text-lg mb-1">
        {{ project.ref }} Annex B
      </h2>
    </div>
    <div class="text-grey-700 text-sm mb-6">
      <div v-html="parseMarkdown(project.conditions)" />
      <p
        v-if="!project.conditions_evidence_file_id"
        class="text-neutral-800 mt-2 p-1 border border-neutral-500 bg-neutral-100"
      >
        <b>Please upload your Pubication Request Form (Annex B) below.</b>
      </p>
      <p
        v-else-if="!project.conditions_evidence_approved_at"
        class="text-neutral-800 mt-2"
      >
        <b>
          Your Publication Request Form is being reviewed by your monitoring
          officer. You will be notified when it has been approved.
        </b>
      </p>
      <input
        v-if="
          !project.conditions_evidence_file_id &&
            authUser.isLead &&
            authUser.isEditor
        "
        ref="upload"
        class="sr-only"
        type="file"
        accept=".pdf,.docx,.doc,.xlsx,.xls,.zip,.ppt,pptx"
        :disabled="loading"
        @input="uploadContractConditions"
      />
    </div>
    <div class="border-t pt-4 mt-auto flex items-center justify-end">
      <p
        v-if="loading"
        class="text-primary-500 italic text-sm"
      >
        Uploading...
      </p>
      <icon-link
        v-else-if="project.conditions_evidence_file_id"
        :href="
          route('applications.files.download', {
            application: project.uuid,
            file: project.conditions_evidence_file_id
          }) + '?project=1'
        "
        class="ml-auto"
        icon="cheveron-down-circle"
        icon-placement="right"
        target="_blank"
      >
        Download
      </icon-link>
      <icon-link
        v-else-if="authUser.isLead && authUser.isEditor"
        href="#"
        class="ml-auto"
        icon="arrow-thick-up-circle"
        icon-placement="right"
        target="_blank"
        @click.prevent="focusUpload"
      >
        Upload
      </icon-link>
      <p
        v-else
        class="italic text-xs text-neutral-500"
      >
        The lead applicant's organisation is reponsible for uploading your
        Publication Request Form (Annex B).
      </p>
    </div>
  </app-card>
</template>

<script>
export default {
  name: "UserConditionsCard",
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    authUser() {
      return window._user;
    }
  },
  mounted() {
    if (window.location.hash === "#conditions-card") {
      window.scrollTo(0, this.$el.offsetTop);
    }
  },
  methods: {
    focusUpload() {
      if (this.loading) return;
      return this.$refs.upload.click();
    },
    validFile(file) {
      const errors = [];

      if (file.size / 1024 / 1024 > 5)
        errors.push(`This file exceeds the upload limit of 5mb`);

      if (errors.length) {
        file["errors"] = errors;
      }
      return file;
    },
    uploadContractConditions() {
      const fileUpload = this.$refs.upload;
      const inputFiles = fileUpload.files;

      if (
        (!this.authUser.isLead && !this.authUser.isEditor) ||
        !inputFiles.length
      )
        return;

      let formData = new FormData();
      this.loading = true;

      formData.append("parent_key", "conditions_evidence_upload");
      formData.append("key", "conditions_evidence");
      formData.append("action", "conditions_evidence_uploaded");

      let file = this.validFile(inputFiles[0]);
      if (file.hasOwnProperty("errors")) {
        alert(file.errors[0]);
      } else {
        formData.append(`conditions_evidence[0]`, file);
      }

      axios
        .post(route("applications.upload", this.project.uuid), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(({ data }) => {
          formData = null;
          fileUpload.setAttribute("files", null);
          fileUpload.setAttribute("value", "");
          Turbolinks.visit(window.location.toString(), { action: "replace" });
        })
        .catch(({ response, data }) => {
          window.alert("Unable to upload your file, please try again later.");
        });
    }
  }
};
</script>

<style scoped>
::v-deep.card:target {
  outline: 0.5rem solid config("colors.neutral-500");
}
</style>
